import { Injectable } from '@angular/core';
import { resolve } from '../util/resolve';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FornecedorClienteServices {
  constructor(
    private http: HttpClient
  ) {}

  buscarFornecedoresClientes(): Observable<any> {
    const url = resolve('refactory://clienteFornecedor');
    return this.http.get<any>(url).pipe(
      map((result: any) => result.items)
    );
  }

  salvarFornecedoresClientes(solicitacao: SolicitacaoFornecedoresClientes) {
    const url = resolve('refactory://solicitacaoFornecedorCliente');
    return this.http.post(url, solicitacao);
  }

  salvarFornecedoresClientesOutros(solicitacao: SolicitacaoFornecedoresClientes) {
    const url = resolve('refactory://solicitacaoFornecedorClienteOutros');
    return this.http.post(url, solicitacao);
  }

  deletarSolicitacaoFornecedoresClientes(idSolicitacao: number) {
    const url = resolve('refactory://solicitacaoFornecedorCliente/idSolicitacao', { idSolicitacao });
    return this.http.delete(url);
  }

  buscarSolicitacaoFornecedoresClientes(idSolicitacao: number) {
    const url = resolve('refactory://solicitacaoFornecedorCliente/idSolicitacao', { idSolicitacao });
    return this.http.get(url).pipe(
      map((result: any) => result.data)
    );
  }
}

export interface SolicitacaoFornecedoresClientes {
  tipoFornecedorCliente?: string;
  solicitacao?: number;
  clienteFornecedor?: number;
  nome?: string;
}


